import { createUseStyles, useDarkMode } from '@glu/theming';
import PropTypes from 'prop-types';
import React from 'react';
import locale from '@glu/locale';
import classnames from 'classnames';
import Badge from './Badge';
import styles from './SelectString.styles';
import './themeDefaults';

const useStyles = createUseStyles(styles);

const SelectString = ({
  applySelection,
  disabled,
  format,
  placeholder,
  selection,
  showBadges,
  showSelected,
  onClick
}) => {
  const dark = useDarkMode();
  const classes = useStyles();

  let selectionString = false;

  const selectionLength = selection.length;

  if (selectionLength) {
    if (selectionLength > showSelected) {
      selectionString = `${selectionLength} ${locale.get('selected')}`;
    } else if (showBadges) {
      return selection
        .sort((a, b) => ((a.name < b.name) ? -1 : 1)).map((option, index) => (
          <Badge
            applySelection={applySelection}
            disabled={disabled}
            index={index}
            key={option.id}
            option={option}
            selection={selection}
            onClick={onClick}
          />
        ));
    } else {
      selectionString = format(selection);
    }
  }

  return (
    <button
      data-qa="input-value"
      className={classnames(
        classes.placeholder, { [classes.dark]: dark, [classes.disabled]: disabled }
      )}
      onClick={onClick}
      type="button"
      tabIndex="-1"
    >
      {selectionString || placeholder}
    </button>
  );
};

SelectString.propTypes = {
  applySelection: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  format: PropTypes.func.isRequired,
  /** Default value for select field's button content. Required to not be empty for A11y */
  placeholder: PropTypes.string.isRequired,
  /** All options currently selected */
  selection: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    name: PropTypes.string.isRequired,
    parentName: PropTypes.string
  })).isRequired,
  /** UX setting to display selection as individually clearable items */
  showBadges: PropTypes.bool.isRequired,
  /** Number of options to show in the select field before fallback to "N selected" message* */
  showSelected: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired
};

export default SelectString;
